
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, MapPin, AlertTriangle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Extract potential city slug from URL for helpful suggestions
  const pathParts = location.pathname.split('/');
  const cityIndex = pathParts.indexOf('city');
  const potentialSlug = cityIndex !== -1 ? pathParts[cityIndex + 1] : null;

  return (
    <>
      <div className="container mx-auto px-4 py-24 min-h-[calc(100vh-200px)] flex items-center justify-center">
        <div className="max-w-md w-full text-center bg-white rounded-xl border border-slate-200 shadow-lg p-8 md:p-10 animate-fade-in">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-600 mb-6">
            <AlertTriangle className="h-8 w-8" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-3">
            {t("pageNotFound")}
          </h1>
          
          <p className="text-slate-600 mb-4">
            {t("pageNotFoundDesc")}
          </p>

          {potentialSlug && (
            <div className="mb-6 p-4 bg-slate-50 rounded-lg border border-slate-200">
              <div className="flex items-center justify-center gap-2 mb-2">
                <MapPin className="h-4 w-4 text-slate-500" />
                <p className="text-sm text-slate-600">
                  Looking for: <code className="font-mono font-semibold">{potentialSlug}</code>
                </p>
              </div>
              <p className="text-xs text-slate-500">
                This city might not be in our database yet, or the URL might be incorrect.
              </p>
            </div>
          )}
          
          <div className="flex flex-col space-y-3">
            <Button
              className="bg-blue-500 hover:bg-blue-600 w-full"
              asChild
            >
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                {t("backToHome")}
              </Link>
            </Button>
            
            <Button
              variant="outline"
              className="border-slate-200 w-full"
              onClick={() => navigate('/cities')}
            >
              <MapPin className="mr-2 h-4 w-4" />
              Browse All Cities
            </Button>

            <Button
              variant="ghost"
              className="w-full"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t("goBack")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
